import React from 'react';
import PropTypes from 'prop-types';

import { PSPModuleWrapper } from 'components/psp/PSPModuleWrapper';
import { CityLandingPages } from 'components/landing/CityLandingPages';

export default function PSPCities({ title, cities, image, className }) {
	return (
		<PSPModuleWrapper>
			<CityLandingPages
				headline={title}
				cities={cities}
				fillOrder="vertical"
				image={image}
				className={className}
			/>
		</PSPModuleWrapper>
	);
}

PSPCities.propTypes = {
	title: PropTypes.string.isRequired,
	cities: PropTypes.arrayOf(PropTypes.object).isRequired,
	image: PropTypes.string,
	className: PropTypes.string,
};
